import { render, staticRenderFns } from "./CommonDialogsContainer.vue?vue&type=template&id=4314c497&"
import script from "./CommonDialogsContainer.vue?vue&type=script&lang=ts&"
export * from "./CommonDialogsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports